"use strict";
var food = {
    Drink: {
        Wine: {},
        Schnaps: {}
    },
    Fruit: {
        Red: {
            Cherry: {},
            Strawberry: {}
        },
        Yellow: {
            Banana: {},
            Pineapple: {}
        }
    }
};
function createTree(element, data) {
    if (Object.keys(data).length === 0) return;
    var ul = document.createElement("ul");
    for(var key in data){
        var li = document.createElement("li");
        li.textContent = key;
        createTree(li, data[key]);
        ul.append(li);
    }
    element.append(ul);
}
var tree = document.querySelector("#tree");
createTree(tree, food);

//# sourceMappingURL=index.44d469d1.js.map
